// libraries
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import RoundedBox from '/react4xp/components/RoundedBox'
import RichText from '/react4xp/components/RichText'
import Link from '/react4xp/components/Link'

// css
import './index.scss'

// types
export interface ContentBoxProps {
    className?: string
    boxColor?: 'beige' | 'green-light'
    title?: string
    description?: string
    cta?: {
        style?: 'link' | 'button'
        label: string
        url?: string
        external?: boolean
    }[]
}

export default function ContentBox({
    className,
    boxColor,
    title,
    description,
    cta
}: ContentBoxProps) {
    return (
        <Section className={clsx('content-box', className)}>
            <div className='container'>
                <RoundedBox
                    bgColor={boxColor}
                    className='content-box__box'
                >
                    <div className='row'>
                        <div className='col-lg-10 offset-lg-1 col-xl-6 offset-xl-3'>

                            {title && (
                                <h2
                                    className='h2 content-box__title'
                                    dangerouslySetInnerHTML={{ __html: title }}
                                    suppressHydrationWarning
                                />
                            )}

                            {description && (
                                <RichText className='content-box__description'>
                                    {description}
                                </RichText>
                            )}

                            {cta && cta.map((item, i) => (
                                item.style === 'link' ? (
                                    <Link
                                        key={i}
                                        className='body'
                                        href={item.url}
                                        isExternal={item.external}
                                        label={{
                                            underline: item.label
                                        }}
                                        icon={{
                                            type: 'arrow-right'
                                        }}
                                    />
                                ) : (
                                    <a
                                        key={i}
                                        href={item.url}
                                        target={item.external ? '_blank' : '_self'}
                                        rel={item.external ? 'noopener noreferrer' : ''}
                                        className='button-hollow-black'
                                    >
                                        {item.label}
                                    </a>
                                )
                            ))}

                        </div>
                    </div>
                </RoundedBox>
            </div>
        </Section>
    )
}